import React, { useState } from 'react'
// icons ------------------------------------------------
import {
  Users,
  Plus,
  CircleInfo,
  UserTag,
  Key,
  EyeIcon,
  PencilLine,
  Check,
  CircleCheck,
  CircleDotted,
  Question,
  CircleXmark,
  ChatDotsFill,
  FileUpload,
  Download,
  Flag,
  UserPlus,
  Search,
  Cross,
  Save
} from '../../../../../../../components/icons/Icons'
import Avatar1 from "../../../../../../../assets/Images/avatar-1.png"
import { Col, Row } from 'react-bootstrap'
import { Switch } from '@mui/material'
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
// components ------------------
import RoleForm from "./RoleForm"

const UserRoles = () => {

  const [addPreIncentive, setAddPreIncentive] = useState({});
  const [isActive, setIsActive] = useState(false);

  const toggleInActive = () => {
    setIsActive(false);
    setAddPreIncentive({});
  };

  return (
    <div>
      <div className='d-flex align-items-center justify-content-between mb-4'>
        <div className='mt-4'>
          <h3 className='color-white font-weight-200'>User Roles & Permissions</h3>
          <h5 className='color-gray font-weight-200 mt-1'>Manage user roles and their access permissions in the TDS module</h5>
        </div>

        <div className='mt-4 d-flex align-items-center gap-2'>
          <Users class_name={"text-purple"} />
          <span className='color-gray'> 4 roles • 247 users</span>
          <button className='universal-btn border-radius-8px d-flex align-items-center gap-2 px-4 py-3' onClick={() => setIsActive(true)}> <Plus /> Add New Role</button>
        </div>
      </div>
      {/* --------------------- */}
      <div className='d-flex align-items-center gap-2 orange-bg-20 border-orange border-radius-8px p-3'>
        <CircleInfo class_name={"font-20 warning-clr"} />
        <div className=''>
          <h3 className='color-white font-weight-200 '>Audit Trail Notice</h3>
          <h4 className='color-white font-weight-200 font-16'>Any role changes are automatically logged in the Audit Trail for compliance and security tracking.</h4>
        </div>
      </div>
      {/* --------------------- */}
      <Row>
        <Col sm="6">
          <section className="setting-border height-auto mt-4 mb-4">
            <div className='setting-card-header'>
              <h3 className='color-white font-weight-200'> <UserTag class_name="section-icon text-purple" /> Payroll Software </h3>
              <span className='color-gray font-14'>4 active roles</span>
            </div>

            <div className='p-4 mb-8'>

              {/* Card 1-------------- */}
              <div className='bg-purple-30 border-purple border-radius-8px p-3 mb-4'>

                <div className='d-flex align-items-center justify-content-between gap-2 mb-4'>
                  <div className='d-flex align-items-center justify-content-start gap-3'>
                    <span className='blue-icon-container'>
                      <EyeIcon class_name={"text-white"} />
                    </span>
                    <div>
                      <h3 className='color-white font-weight-200'>HR Reviewer</h3>
                      <h4 className='color-gray font-weight-200'>Review and flag Form 12BB submissions</h4>
                    </div>
                  </div>
                  <span className='badge-skyblue'>
                    <Users />
                    89 users
                  </span>
                </div>
                {/* ------------------ */}
                <div className='d-flex align-items-center justify-content-between gap-2'>
                  <div className='d-flex align-items-center justify-content-start gap-3'>
                    <span className={"green-text font-weight-200 font-14 d-flex align-items-center justify-content-start gap-1"}><Check /> View Forms</span>
                    <span className={"green-text font-weight-200 font-14 d-flex align-items-center justify-content-start gap-1"}><Check /> Edit Forms</span>
                    <span className={"green-text font-weight-200 font-14 d-flex align-items-center justify-content-start gap-1"}><Check /> Flag Issues</span>
                  </div>
                  <PencilLine class_name={'text-purple font-20'} />
                </div>

              </div>

              {/* Card 2-------------- */}
              <div className='setting-border height-auto p-3 mb-4'>
                <div className='d-flex align-items-center justify-content-between gap-2 mb-4'>
                  <div className='d-flex align-items-center justify-content-start gap-3'>
                    <span className='green-icon-container '>
                      <CircleCheck class_name={"text-white"} />
                    </span>
                    <div>
                      <h3 className='color-white font-weight-200'>HR Approver</h3>
                      <h4 className='color-gray font-weight-200'>Final authority to approve or reject forms</h4>
                    </div>
                  </div>
                  <span className='badge-green'>
                    <Users />
                    89 users
                  </span>
                </div>
                {/* ------------- */}
                <div className='d-flex align-items-center justify-content-between gap-2'>
                  <div className='d-flex align-items-center justify-content-start gap-3'>
                    <span className={"green-text font-weight-200 font-14 d-flex align-items-center justify-content-start gap-1"}><Check />All Permissions</span>
                    <span className={"green-text font-weight-200 font-14 d-flex align-items-center justify-content-start gap-1"}><Check />Final Approval</span>
                  </div>
                  <PencilLine class_name={'text-purple font-20'} />
                </div>
              </div>

              {/* Card 3-------------- */}
              <div className='setting-border height-auto p-3 mb-4'>
                <div className='d-flex align-items-center justify-content-between gap-2 mb-4'>
                  <div className='d-flex align-items-center justify-content-start gap-3'>
                    <span className='yellow-icon-container '>
                      <CircleCheck class_name={"text-white"} />
                    </span>
                    <div>
                      <h3 className='color-white font-weight-200'>Payroll Auditor</h3>
                      <h4 className='color-gray font-weight-200'>View locked forms and verify calculations</h4>
                    </div>
                  </div>
                  <span className='badge-yellow'>
                    <Users />
                    89 users
                  </span>
                </div>
                {/* ------------- */}
                <div className='d-flex align-items-center justify-content-between gap-2'>
                  <div className='d-flex align-items-center justify-content-start gap-3'>
                    <span className={"green-text font-weight-200 font-14 d-flex align-items-center justify-content-start gap-1"}><Check />View Locked</span>
                    <span className={"green-text font-weight-200 font-14 d-flex align-items-center justify-content-start gap-1"}><Check />Verify Calcs</span>
                    <span className={"green-text font-weight-200 font-14 d-flex align-items-center justify-content-start gap-1"}><Check />Export Data</span>
                  </div>
                  <PencilLine class_name={'text-purple font-20'} />
                </div>
              </div>

              {/* Card 4-------------- */}
              <div className='setting-border height-auto p-3 mb-4'>
                <div className='d-flex align-items-center justify-content-between gap-2 mb-4'>
                  <div className='d-flex align-items-center justify-content-start gap-3'>
                    <span className='gray-icon-container'>
                      <CircleCheck class_name={"text-white"} />
                    </span>
                    <div>
                      <h3 className='color-white font-weight-200'>Employee</h3>
                      <h4 className='color-gray font-weight-200'>Submit and edit their own Form 12BB</h4>
                    </div>
                  </div>
                  <span className='badge-gray'>
                    <Users />
                    2,138 users
                  </span>
                </div>
                {/* ------------- */}
                <div className='d-flex align-items-center justify-content-between gap-2'>
                  <div className='d-flex align-items-center justify-content-start gap-3'>
                    <span className={"green-text font-weight-200 font-14 d-flex align-items-center justify-content-start gap-1"}><Check />Own Forms Only</span>
                    <span className={"green-text font-weight-200 font-14 d-flex align-items-center justify-content-start gap-1"}><Check />Submit & Edit</span>
                  </div>
                  <PencilLine class_name={'text-purple font-20'} />
                </div>
              </div>

            </div>
          </section>
        </Col>
        {/* Col ends here -------- */}
        <Col sm="6">
          <section className="setting-border height-auto mt-4 mb-4">
            <div className='setting-card-header'>
              <h3 className='color-white font-weight-200'> <Key class_name="section-icon text-purple" /> Permissions & Assignments</h3>
              <span className='color-gray font-14'>HR Reviewer</span>
            </div>

            <div className='p-4 mb-4'>

              <h3 className='d-flex align-items-center gap-2 color-white font-weight-200 font-16 mb-4'>
                <div className='two-icons' style={{ marginTop: "-4px", marginLeft: "9px", marginRight: "10px" }}>
                  <CircleDotted class_name="section-icon text-purple icon font-20" /> <Question class_name="section-icon text-purple icon-1" />
                </div>
                Permissions
              </h3>

              <div className='integration-card active height-auto p-3 mb-4'>

                <div className='d-flex align-items-center justify-content-between gap-2 mb-4'>

                  <div>
                    <div className='d-flex align-items-center justify-content-start gap-3 mb-3'>
                      <EyeIcon class_name={"info-text"} />
                      <h3 className='color-white font-weight-200'>View Forms</h3>
                    </div>

                    <h4 className='color-gray font-weight-200 font-14'>Access to view Form 12BB submissions</h4>

                  </div>
                  <Switch checked />
                </div>
              </div>
              {/* Card 1 ends ------------------ */}

              <div className='integration-card active height-auto p-3 mb-4'>

                <div className='d-flex align-items-center justify-content-between gap-2 mb-4'>

                  <div>
                    <div className='d-flex align-items-center justify-content-start gap-3 mb-3'>
                      <PencilLine class_name={"info-text font-20"} />
                      <h3 className='color-white font-weight-200'>Edits Forms</h3>
                    </div>

                    <h4 className='color-gray font-weight-200 font-14'>Modify form data and calculations</h4>

                  </div>
                  <Switch checked />
                </div>
              </div>
              {/* Card 2 ends ------------------ */}

              <div className='setting-border height-auto p-3 mb-4'>

                <div className='d-flex align-items-center justify-content-between gap-2 mb-4'>

                  <div>
                    <div className='d-flex align-items-center justify-content-start gap-3 mb-3'>
                      <CircleCheck class_name={"text-gray "} />
                      <h3 className='text-gray  font-weight-200'>Approve Forms</h3>
                    </div>

                    <h4 className='color-gray font-weight-200 font-14'>Final approval authority for submissions</h4>

                  </div>
                  <Switch checked />
                </div>
              </div>
              {/* Card 3 ends ------------------ */}

              <div className='setting-border height-auto p-3 mb-4'>

                <div className='d-flex align-items-center justify-content-between gap-2 mb-4'>

                  <div>
                    <div className='d-flex align-items-center justify-content-start gap-3 mb-3'>
                      <CircleXmark class_name={"text-gray "} />
                      <h3 className='text-gray  font-weight-200'>Reject Forms</h3>
                    </div>

                    <h4 className='color-gray font-weight-200 font-14'>Authority to reject submissions</h4>

                  </div>
                  <Switch checked />
                </div>
              </div>
              {/* Card 4 ends ------------------ */}

              <div className='integration-card active height-auto p-3 mb-4'>

                <div className='d-flex align-items-center justify-content-between gap-2 mb-4'>

                  <div>
                    <div className='d-flex align-items-center justify-content-start gap-3 mb-3'>
                      <ChatDotsFill class_name={"yellow-text"} />
                      <h3 className='color-white font-weight-200'>Request Edit</h3>
                    </div>

                    <h4 className='color-gray font-weight-200 font-14'>Send edit requests to employees</h4>

                  </div>
                  <Switch checked />
                </div>
              </div>
              {/* Card 5 ends ------------------ */}

              <div className='setting-border height-auto p-3 mb-4'>

                <div className='d-flex align-items-center justify-content-between gap-2 mb-4'>

                  <div>
                    <div className='d-flex align-items-center justify-content-start gap-3 mb-3'>
                      <FileUpload class_name={"text-gray "} />
                      <h3 className='text-gray  font-weight-200'>Upload Form 16</h3>
                    </div>

                    <h4 className='color-gray font-weight-200 font-14'>Upload and manage Form 16 documents</h4>

                  </div>
                  <Switch checked />
                </div>
              </div>
              {/* Card 6 ends ------------------ */}


              <div className='setting-border height-auto p-3 mb-4'>

                <div className='d-flex align-items-center justify-content-between gap-2 mb-4'>

                  <div>
                    <div className='d-flex align-items-center justify-content-start gap-3 mb-3'>
                      <Download class_name={"text-gray "} />
                      <h3 className='text-gray  font-weight-200'>Export Data</h3>
                    </div>

                    <h4 className='color-gray font-weight-200 font-14'>Export reports and data files</h4>

                  </div>
                  <Switch checked />
                </div>
              </div>
              {/* Card 7 ends ------------------ */}

              <div className='integration-card active height-auto p-3 mb-4'>

                <div className='d-flex align-items-center justify-content-between gap-2 mb-4'>

                  <div>
                    <div className='d-flex align-items-center justify-content-start gap-3 mb-3'>
                      <Flag class_name={"gageri-text"} />
                      <h3 className='color-white font-weight-200'>Flag Issues</h3>
                    </div>

                    <h4 className='color-gray font-weight-200 font-14'>Mark forms with compliance issues</h4>

                  </div>
                  <Switch checked />
                </div>
              </div>
              {/* Card 8 ends ------------------ */}

              <div className='d-flex align-items-center justify-content-between gap-2 mb-4'>
                <h3 className='d-flex align-items-center gap-2 color-white font-weight-200'><UserPlus class_name={'text-purple'} /> Assign Employees</h3>
                <span className='text-gray'>89 assigned</span>
              </div>


              <div className='setting-border height-auto d-flex align-items-center gap-2 text-gray p-3 mb-4'>
                <Search /> Search employees by name, email, or employee ID...
              </div>

              {/* Card 1-------------- */}
              <div className='bg-purple-30 border-purple border-radius-8px p-3 mb-4'>
                <div className='d-flex align-items-center justify-content-between gap-2'>
                  <div className='d-flex align-items-center justify-content-start gap-3'>
                    <div className='avatar-badge'>
                      <img src={Avatar1} alt='Avatar1' />
                    </div>
                    <div>
                      <h3 className='color-white font-weight-200'>Rajesh Kumar</h3>
                      <h4 className='color-gray font-weight-200'>EMP001 • rajesh.kumar@company.com</h4>
                    </div>
                  </div>
                  <div className='d-flex align-items-center gap-2'></div>
                  <span className='badge-skyblue'>
                    HR Reviewer
                  </span>
                  <button className='bg-red text-white d-flex align-items-center justify-content-start gap-2 p-1 px-3 border-radius-8px'> <Cross /> Remove </button>
                </div>
              </div>
              {/* Card 2--------------------- */}
              <div className='bg-purple-30 border-purple border-radius-8px p-3 mb-4'>
                <div className='d-flex align-items-center justify-content-between gap-2'>
                  <div className='d-flex align-items-center justify-content-start gap-3'>
                    <div className='avatar-badge'>
                      <img src={Avatar1} alt='Avatar1' />
                    </div>
                    <div>
                      <h3 className='color-white font-weight-200'>Rajesh Kumar</h3>
                      <h4 className='color-gray font-weight-200'>EMP001 • rajesh.kumar@company.com</h4>
                    </div>
                  </div>
                  <div className='d-flex align-items-center gap-2'></div>
                  <span className='badge-skyblue'>
                    HR Reviewer
                  </span>
                  <button className='bg-red text-white d-flex align-items-center justify-content-start gap-2 p-1 px-3 border-radius-8px'> <Cross /> Remove </button>
                </div>
              </div>

              {/* Card 2--------------------- */}
              <div className='height-auto setting-border border-radius-8px p-3 mb-4'>
                <div className='d-flex align-items-center justify-content-between gap-2'>
                  <div className='d-flex align-items-center justify-content-start gap-3'>
                    <div className='avatar-badge'>
                      <img src={Avatar1} alt='Avatar1' />
                    </div>
                    <div>
                      <h3 className='color-white font-weight-200'>Rajesh Kumar</h3>
                      <h4 className='color-gray font-weight-200'>EMP001 • rajesh.kumar@company.com</h4>
                    </div>
                  </div>
                  <div className='d-flex align-items-center gap-2'></div>
                  <span className='badge-gray'>
                    Employee
                  </span>
                  <button className='universal-btn d-flex align-items-center justify-content-start gap-2 p-1 px-3 border-radius-8px'> <Plus /> Remove </button>
                </div>
              </div>

              {/* Card 2--------------------- */}
              <div className='height-auto setting-border border-radius-8px p-3 mb-4'>
                <div className='d-flex align-items-center justify-content-between gap-2'>
                  <div className='d-flex align-items-center justify-content-start gap-3'>
                    <div className='avatar-badge'>
                      <img src={Avatar1} alt='Avatar1' />
                    </div>
                    <div>
                      <h3 className='color-white font-weight-200'>Rajesh Kumar</h3>
                      <h4 className='color-gray font-weight-200'>EMP001 • rajesh.kumar@company.com</h4>
                    </div>
                  </div>
                  <div className='d-flex align-items-center gap-2'></div>
                  <span className='badge-gray'>
                    Employee
                  </span>
                  <button className='universal-btn d-flex align-items-center justify-content-start gap-2 p-1 px-3 border-radius-8px'> <Plus /> Remove </button>
                </div>
              </div>

              {/* Card 2--------------------- */}
              <div className='height-auto setting-border border-radius-8px p-3'>
                <div className='d-flex align-items-center justify-content-between gap-2'>
                  <div className='d-flex align-items-center justify-content-start gap-3'>
                    <div className='avatar-badge'>
                      <img src={Avatar1} alt='Avatar1' />
                    </div>
                    <div>
                      <h3 className='color-white font-weight-200'>Rajesh Kumar</h3>
                      <h4 className='color-gray font-weight-200'>EMP001 • rajesh.kumar@company.com</h4>
                    </div>
                  </div>
                  <div className='d-flex align-items-center gap-2'></div>
                  <span className='badge-gray'>
                    Employee
                  </span>
                  <button className='universal-btn d-flex align-items-center justify-content-start gap-2 p-1 px-3 border-radius-8px'> <Plus /> Remove </button>
                </div>
              </div>
            </div>
          </section>
        </Col>
      </Row>

      <div className='d-flex align-items-center justify-content-end gap-2'>
        <button className='universal-sec-btn border-radius-8px d-flex align-items-center justify-content-center gap-2'><Cross /> Cancel Changes</button>
        <button className='universal-btn border-radius-8px d-flex align-items-center justify-content-center gap-2'> <Save /> Save Changes</button>
      </div>

      <Dialog
        open={isActive}
        keepMounted
        onClose={toggleInActive}
        maxWidth="md" // 'xs', 'sm', 'md', 'lg', 'xl'
        fullWidth
        aria-labelledby="scroll-dialog-title"
        aria-describedby="scroll-dialog-description"
        className="dark-bg-color"
      >
        <DialogTitle className="dialog-title">
          <div className="dialog-title-icon">
            <span className="close-icon" onClick={toggleInActive}>
              X
            </span>
            <span className="title">Add Role</span>
          </div>
          <button
            className="universal-btn border-radius-8px"
          >
            Create Role
          </button>
        </DialogTitle>
        <DialogContent className="pure-dark-bg-color">

          <RoleForm />

        </DialogContent>
      </Dialog>
    </div>
  )
}

export default UserRoles